import { Link } from "react-router-dom";

const BlogCard = ({ post }) => {
  const isExternalLink = /^https?:\/\//i.test(post.href);

  return (
    <article className="overflow-hidden rounded-[22px] border border-[#d9dfe9] bg-white shadow-[0_10px_22px_rgba(36,41,56,0.06)]">
      <div className="relative h-[180px] overflow-hidden sm:h-[200px] lg:h-[180px] xl:h-[200px]">
        <img
          src={post.image}
          alt={post.title}
          className="h-full w-full object-cover object-center"
          loading="lazy"
        />

        <span className={`absolute left-4 top-4 inline-flex items-center rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-white ${post.badgeClass}`}>
          {post.badge}
        </span>

        <span className="absolute bottom-4 right-4 rounded-full bg-[rgba(32,32,32,0.7)] px-3 py-1 text-[12px] font-medium text-white backdrop-blur-[2px]">
          {post.readTime}
        </span>
      </div>

      <div className="px-5 pb-5 pt-4 sm:px-6 sm:pb-6 sm:pt-5">
        <h3 className="min-h-[58px] text-[20px] font-semibold leading-[1.28] tracking-[-0.03em] text-[#22242a] sm:text-[22px] lg:text-[20px] xl:text-[22px]">
          {post.title}
        </h3>

        <p className="mt-3 min-h-[60px] line-clamp-3 text-[14px] leading-[1.7] text-[#6e7687] sm:text-[15px] lg:text-[14px] xl:text-[15px]">
          {post.excerpt}
        </p>

        <div className="mt-4 border-t border-[#e3e7ef] pt-4">
          <div className="flex items-center justify-between gap-4">
            {isExternalLink ? (
              <a
                href={post.href}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center rounded-[8px] bg-[var(--st-color-red)] px-5 py-3 text-[13px] font-semibold text-white transition-colors duration-200 hover:bg-[#a53317]"
              >
                Baca selengkapnya
                <span className="ml-3 text-[14px]" aria-hidden="true">
                  →
                </span>
              </a>
            ) : (
              <Link
                to={post.href}
                className="inline-flex items-center rounded-[8px] bg-[var(--st-color-red)] px-5 py-3 text-[13px] font-semibold text-white transition-colors duration-200 hover:bg-[#a53317]"
              >
                Baca selengkapnya
                <span className="ml-3 text-[14px]" aria-hidden="true">
                  →
                </span>
              </Link>
            )}

            <span className="text-[13px] font-medium text-[#7e8698]">
              {post.date}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;